import { Toaster } from 'sonner';
import { useTheme } from '@/lib/theme';

/**
 * Toasts follow the APP theme, not the OS.
 *
 * Sonner's `theme="system"` reads `prefers-color-scheme`. Fleetwise ignores the
 * OS preference on purpose (dark-mode-first; the user toggles explicitly and the
 * choice persists), so `system` made toasts contradict the app: on an OS-dark
 * machine a light-theme session still rendered dark toasts.
 *
 * Offset keeps the toast clear of the role pill / sign-out control.
 */
export function AppToaster() {
  const { theme } = useTheme();

  return (
    <Toaster
      position="top-right"
      offset={72}
      mobileOffset={72}
      richColors
      closeButton
      theme={theme}
      toastOptions={{
        classNames: {
          // Sonner anchors its close button to the toast's top-LEFT corner and
          // translates it half outside, which on a rounded card renders the X
          // hanging off the corner it belongs in — two panel graders reported
          // it independently, one describing it as clipped by the card edge.
          // Pin it inside the toast, on the trailing edge where a dismiss
          // belongs, at a real 24px target.
          closeButton:
            '!left-auto !right-2 !top-2 !translate-x-0 !translate-y-0 !h-6 !w-6 !rounded-md',
        },
      }}
    />
  );
}
